
import Vue from 'vue';
import _ from 'lodash';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    loadingManifestDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    deliveryAlias: function(): string {
      return _.get(this.loadingManifestDetails, this.input.config.deliveryAddressRefVariable, '');
    }
  },
  methods: {
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
